import React from "react";
import NetworkElementUpperSection from "./networkElementUpperSection";
import NetworkElementBottomSection from "./networkElementBottomSection";
import BandwidthBox from "./bandwidthBox";
import { useGroup } from "../ManagePorts/GroupOperations/useGroup";
interface NetworkElementBoxProps {
  title: string;
  networkElementOptions: any[];
  selectedNetworkElement: any;
  portsInfo: any[];
  portDescription: string;
  onNetworkElementChange: (value: any) => void;
  onPortDescriptionChange: (_: any) => void;
  onPortNameChange: (portTempId: number, portName: string) => void;
  onKeypress: (_: any) => void;
  verifyPorts: boolean;
  handleVerifyChange: () => void;
  inputValue: string;
  onInputChange: (_: string) => void;
  bandwidthProps?: any;
  useGroupProps?: ReturnType<typeof useGroup>;
  portPrefix: string;
  handlePortPrefixChange: (_: string) => void;
}

const NetworkElementBox: React.FC<NetworkElementBoxProps> = ({
  bandwidthProps,
  title,
  verifyPorts,
  inputValue,
  onInputChange,
  handleVerifyChange,
  networkElementOptions,
  selectedNetworkElement,
  portsInfo,
  portDescription,
  onPortDescriptionChange,
  useGroupProps,
  onPortNameChange,
  onKeypress,
  onNetworkElementChange,
  portPrefix,
  handlePortPrefixChange
}) => {
  return (
    <div className="ne-box-root">
      <h3>{title}</h3>
      <div className="box network-element">
        {bandwidthProps ? (
          <BandwidthBox {...bandwidthProps} />
        ) : (
          <NetworkElementUpperSection
            inputValue={inputValue}
            onInputChange={onInputChange}
            verifyPorts={verifyPorts}
            handleVerifyChange={handleVerifyChange}
            type={title.includes("Near End") ? "ne" : "fe"}
            onNetworkElementChange={onNetworkElementChange}
            onKeypress={onKeypress}
            onPortDescriptionChange={onPortDescriptionChange}
            portDescription={portDescription}
            networkElementOptions={networkElementOptions}
            selectedNetworkElement={selectedNetworkElement}
            useGroupProps={useGroupProps}
          />
        )}
        <NetworkElementBottomSection
          link={!!bandwidthProps}
          portsInfo={portsInfo}
          onPortNameChange={onPortNameChange}
          onKeypress={onKeypress}
          isValidPortName={useGroupProps?.GroupDropdownProps.IsPortNameValid}
          portPrefix={portPrefix}
          handlePortPrefixChange={handlePortPrefixChange}
        />
      </div>
    </div>
  );
};

export default NetworkElementBox;
